import styled from 'styled-components';
import * as R from 'ramda';

// http://paletton.com/#uid=13X0u0k1DFA00++0iRX47vO88sw
const backgroundColor = '#EFEFEF';
const mainColor = '#A9A9A9';
const accentColor = '#FF3B3F';
const highlightColor = 'CAEBF2';
const fontColor = '#000000';

const Flex = styled.div`
  display: flex;
  height: ${ R.propOr("auto", "height") }
  flex-flow: ${ R.propOr("row", "direction") }
  justify-content: ${ R.propOr("inherit", "justify") }
  align-items: ${R.propOr("inherit", "align")}
  `;

const Box = styled.div`
  flex: ${props => props.flex ? props.flex : "1" };
  height: ${props => props.height || "auto" }`;

const StyledApp = styled.div`
  height: 924px;

  .App-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: ${fontColor};
    margin: 8px 160px 8px 160px;
    border-bottom: 1px solid ${accentColor};
  }
`;

const Grid = styled.div`
  display: flex;
  background: white;
  padding: 24px;
  margin-left: 184px;
  margin-right: 184px;
  flex-flow: column;
  height: 800px;
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  flex: ${R.propOr("1", "flex")};
`;

const Col = styled.div`
  flex: 1;
  width: 50%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  border-radius: 1px;
`;

const borderStyle = '3px solid white';

const CellTerminal = styled(Col)`
border-right: ${borderStyle};
border-top: ${borderStyle};
`;

const CellResults = styled(Col)`
 border-left: ${borderStyle}
 border-top: ${borderStyle};
 justify-content: flex-start;
 padding-left: 32px;
`;

export {
  backgroundColor, mainColor, accentColor, fontColor, borderStyle,
  StyledApp, Grid, Row, Col, Flex, Box,
  CellTerminal, CellResults };